import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { AdvSearchEvent } from '../../models/adv-search-event-model';
import { MetadataProp } from '../../models/metadata-prop-model';
import { SearchComboItemModel } from '../../models/search-combo-item-model';
import { SuggestRequestModel } from '../../models/suggest-request-model';
import { ConstantsService } from '../../services/constants.service';
import { FormsService } from '../../services/forms.service';
import { MetadataService } from '../../services/metadata.service';
import { PubSearchService } from '../../services/pub-search.service';

@Component({
  selector: 'app-search-property-form',
  templateUrl: './search-property-form.component.html',
  styleUrls: ['./search-property-form.component.css']
})
export class SearchPropertyFormComponent implements OnInit {

  @Input() operatorType: string;
  @Input() mdItems?: MetadataProp[];
  @Input() headerMsg?: string;
  @Input() props!: FormArray;
  @Input() searchForm!: FormGroup

  @Output() addProperty = new EventEmitter<any>();
  @Output() removeProperty = new EventEmitter<any>();
  @Output() clearProperty = new EventEmitter<any>();
  @Output() selectProperty = new EventEmitter<any>();
  @Output() toggleDateProperty = new EventEmitter<any>();

  spaceOperator: string = ' ';
  notOperator: string = '-';
  showCombined = false;
  aSugs: string[] = [];
  aFacetSugs: string[] = [];
  instanceName: string;

  constructor(private fb: FormBuilder, private formSvc: FormsService,
    private mdSvc: MetadataService,
    private searchSvc: PubSearchService,
    public constants: ConstantsService) {
    this.operatorType = this.constants.property_operator_all;
    this.instanceName = '';
  }

  ngOnInit(): void {
    this.instanceName = this.operatorType;
    this.mdItems = this.mdSvc.getSearchable();
  }

  getPropSuggestions(event: any, mdItemId: string, op: string) {
    if (!mdItemId) {
      this.aFacetSugs =[];
      return;
    }

    let mdItem = this.mdItems?.find((m) => m.id == mdItemId) as MetadataProp;
    let propertyName = mdItem.cogSearchKey;

    let suggestQuery: SuggestRequestModel = { q: event.query, propertyName: propertyName, suggester: "sg", operation: op };
    this.searchSvc.getFacetSuggestions(suggestQuery).subscribe((data: string[]) => {
      this.aFacetSugs = data;
    });
  }

  handleKeywordDropDown(event: any) {

  }

  updateProp(prop: SearchComboItemModel): FormGroup {
    return this.fb.group({
      propertyItem: prop.propertyItem,
      keywords: prop.keywords,
      startDate: prop.startDate,
      endDate: prop.endDate,
      dateOperator: prop.dateOperator,
      textOperator: prop.textOperator,
      isDate: false
    });
  }

  updateDateProp(prop: SearchComboItemModel): FormGroup {
    return this.fb.group({
      propertyItem: prop.propertyItem,
      keywords: prop.keywords,
      startDate: prop.startDate,
      endDate: prop.endDate,
      dateOperator: prop.dateOperator,
      textOperator: prop.textOperator,
      isDate: true
    });
  }

  addProp() {
    let e: AdvSearchEvent = {
      operatorType: this.operatorType
    }
    this.addProperty.emit(e);
  }

  removeProp(index: number) {
    let e: AdvSearchEvent = {
      operatorType: this.operatorType,
      data: index
    }
    this.removeProperty.emit(e);
  }

  clearProp(index: number) {
    let e: AdvSearchEvent = {
      operatorType: this.operatorType,
      data: index
    }
    this.clearProperty.emit(e);
  }

  selectedProp(index: number) {
    let e: AdvSearchEvent = {
      operatorType: this.operatorType,
      data: index
    }
    this.selectProperty.emit(e);
  }

  toggleDateOp(index: number) {
    let e: AdvSearchEvent = {
      operatorType: this.operatorType,
      data: index
    }
    this.toggleDateProperty.emit(e);
  }
}
